import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const CustomerTargeting = lazy(() => import('../components/CustomerTargeting'));
const PlaybookAnalytics = lazy(() => import('../components/Analytics/PlaybookAnalytics'));
const PlaybookList = lazy(() => import('../components/PlaybookList/PlaybookList'));

const CustomerTargetingRoutes: RouteObject[] = [
  { path: 'settings/modules/customer-targeting', element: <PlaybookList /> },
  { path: 'settings/modules/customer-targeting/new', element: <CustomerTargeting /> },
  { path: 'settings/modules/customer-targeting/playbooks/:playbookId', element: <CustomerTargeting /> },
  { path: 'settings/modules/customer-targeting/playbooks/:playbookId/analytics', element: <PlaybookAnalytics /> },
];

export default CustomerTargetingRoutes;
